import { address_server_socket } from 'config';
import { makeAutoObservable } from 'mobx';

class SocketStore {
  socket = null;
  isConnected = false;
  subscriptions = new Map();
  messageQueue = [];

  constructor() {
    makeAutoObservable(this);
  }

  connect(url = address_server_socket) {
    if (this.socket) return;

    this.socket = new WebSocket(url);

    this.socket.onopen = () => {
      console.log('✅ WebSocket подключен');
      this.isConnected = true;

      // Отправляем все накопленные сообщения
      this.messageQueue.forEach((msg) => this.send(msg));
      this.messageQueue = [];
    };

    this.socket.onclose = () => {
      console.log('🔌 WebSocket отключен. Переподключение...');
      this.socket = null;
      this.isConnected = false;
      setTimeout(() => this.connect(url), 3000);
    };

    this.socket.onerror = (err) => {
      console.error('⚠ WebSocket ошибка:', err);
    };

    this.socket.onmessage = (event) => {
      const message = JSON.parse(event.data);
      const { channel } = message;

      if (this.subscriptions.has(channel)) {
        this.subscriptions.get(channel).forEach((cb) => cb(message));
      }
    };
  }

  subscribe(channel, data, callback) {
    if (!this.subscriptions.has(channel)) {
      this.subscriptions.set(channel, []);
    }
    this.subscriptions.get(channel).push(callback);

    this.send({ channel, action: 'subscribe', data });

    return () => this.unsubscribe(channel, data, callback);
  }

  unsubscribe(channel, data, callback) {
    if (this.subscriptions.has(channel)) {
      this.subscriptions.set(
        channel,
        this.subscriptions.get(channel).filter((cb) => cb !== callback),
      );
    }
    this.send({ channel, action: 'unsubscribe', data });
  }

  send(message) {
    if (this.socket?.readyState === WebSocket.OPEN) {
      this.socket.send(JSON.stringify(message));
    } else {
      this.messageQueue.push(message);
    }
  }
}

export const socketStore = new SocketStore();
